
import { defineComponent, watch, onMounted, computed, ref } from "vue";
import KTSearch from "@/layout/header/partials/Search.vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";
import NotificationStore from "@/store/notification";
import { hasPermissionWrapper } from "@/core/services/permission.service";
import { VZ_PERMISSIONS } from "@/helpers/permissionMapper";
import {
  FETCH_NOTIFICATION,
  GET_EMAIL_NOTIFICATION,
  GET_NOTIFICATION__SUBSCRIPTION,
  GET_SMS_NOTIFICATION,
  NOTIFICATION_STORE,
  SET_NOTIFICATION_SUBSCRIPTION,
} from "@/store/notification/types";
import { INotificationData } from "@/interfaces/iNotification";
import { ICurrentUser } from "@/interfaces/iCurrentUser";
import { FileAPI } from "@/services/api/File.service";
export default defineComponent({
  name: "topbar",
  components: {
    KTSearch,
    KTUserMenu,
  },
  setup() {
    const store = useStore();
    getModule(NotificationStore);
    const emailCount = computed(() => {
      const key = `${NOTIFICATION_STORE}/${GET_EMAIL_NOTIFICATION}`;
      return store.getters[key] as number;
    });
    const smsCount = computed(() => {
      const key = `${NOTIFICATION_STORE}/${GET_SMS_NOTIFICATION}`;
      return store.getters[key] as number;
    });
    const notificationData = computed(() => {
      const key = `${NOTIFICATION_STORE}/${GET_NOTIFICATION__SUBSCRIPTION}`;
      return store.getters[key] as INotificationData;
    });
    const currentUser = computed(() => {
      return store.getters.currentUser as ICurrentUser;
    });
    const imgSrc = ref();
    const getImageData = async () => {
      if (!currentUser.value.fileId) {
        return;
      }
      try {
        const response = await FileAPI.getInstance().fetchImageWithMetaData(
          currentUser.value.fileId
        );

        if (response) {
          const { data } = response;
          const uint8ArrayData = new Uint8Array(data);
          const text = new TextDecoder().decode(uint8ArrayData);
          let decodeData = JSON.parse(text);
          if (decodeData.deleted != 1) {
            imgSrc.value = decodeData.fileUrl;
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        //
      }
    };
    onMounted(async () => {
      await store.dispatch(`${NOTIFICATION_STORE}/${FETCH_NOTIFICATION}`);
      await store.dispatch(
        `${NOTIFICATION_STORE}/${SET_NOTIFICATION_SUBSCRIPTION}`
      );
    });
    onMounted(() => {
      if (currentUser.value.webId) {
        getImageData();
      }
    });
    watch(notificationData, async (val: INotificationData) => {
      if (val) {
        await store.dispatch(`${NOTIFICATION_STORE}/${FETCH_NOTIFICATION}`);
      }
    });
    watch(currentUser, async (val: ICurrentUser, oldVal: ICurrentUser) => {
      if (val && val.webId !== oldVal.webId) {
        await store.dispatch(
          `${NOTIFICATION_STORE}/${SET_NOTIFICATION_SUBSCRIPTION}`
        );
      }
      getImageData();
    });

    return {
      emailCount,
      smsCount,
      hasPermissionWrapper,
      VZ_PERMISSIONS,
      imgSrc,
    };
  },
});
